import { Typography } from '@mui/material'
import get from 'lodash/get'
import { useTranslate } from 'ra-core'
import { FunctionField } from 'react-admin'

import { useCommonStyles } from '../config/theme'

const UnitField = ({
  children,
  unit = 'km',
  formatValue = (v) => v,
  shouldFormatUnit = false,
  addEmptySpace = true,
  ...props
}) => {
  const translate = useTranslate()
  const commonClasses = useCommonStyles()
  return (
    <FunctionField
      {...props}
      render={(record) => {
        const value = get(record, props.source)
        if (!value && value !== 0) {
          return 'n/a'
        }
        return (
          <div style={commonClasses.flexRowCenterContainer}>
            <Typography variant="body2">
              {formatValue(value)}
              {addEmptySpace ? ' ' : ''}
              {shouldFormatUnit ? translate(unit, formatValue(value) || 1) : unit}
            </Typography>
            {children}
          </div>
        )
      }}
    />
  )
}

export default UnitField
